import PropTypes from "prop-types";
import * as React from "react";
import { Link } from "react-router-dom";
import { mutate } from "swr";
import { Influencer } from "../../../domain";
import fetcher from "../../../hooks/fetcher";
import ShopCardImage from "../../../components/ShopCardImage/ShopCardImage";
import UpcomingEvent from "../../../components/Home/Section/UpcomingEvent";
import {
  cardImage,
  cardSourceFromRow,
  shopCardCaption,
} from "../../../domain/shopImages";
import s from "./ShopCard.module.css";

export default function ShopCard({ shop }) {
  const source = cardSourceFromRow(shop);
  const description = shopCardCaption({
    mainLabel: cardImage(source).mainLabel,
    famousFor: shop.famousFor,
    famousCharacter: shop.famousCharacter,
  });

  const handleMouseEnter = React.useCallback(() => {
    const endpoints = Influencer.getPreloadEndpoints(shop);

    if (endpoints) {
      endpoints.filter(Boolean).forEach((endpoint) => {
        mutate(endpoint, fetcher(endpoint));
      });
    }
  }, [shop]);

  return (
    <Link
      to={`/${shop.route}`}
      className={s.card}
      onMouseEnter={handleMouseEnter}
    >
      {shop.isLive ? <span className={s.liveBadge}>LIVE</span> : null}

      <div className={s.imageWrap}>
        <ShopCardImage
          source={source}
          name={shop.name}
          width={162}
          height={216}
        />

        <UpcomingEvent influencer={shop} />
      </div>

      <div className={s.info}>
        <p className={s.name}>{shop.name}</p>
        {Boolean(description) && <p className={s.text}>{description}</p>}
      </div>
    </Link>
  );
}

ShopCard.propTypes = {
  shop: PropTypes.shape({
    influencerId: PropTypes.number,
    route: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    isLive: PropTypes.bool,
    famousFor: PropTypes.string,
    famousCharacter: PropTypes.string,
    cardHeadshot: PropTypes.object,
    cardPrimaryCharacter: PropTypes.object,
  }).isRequired,
};
